import React from 'react';
import clsx from 'clsx';

export default function Error({ className, error }) {
  const defaultClasses = 'text-16 text-errorText';
  const classes = clsx(className, defaultClasses);

  return <h5 className={classes}>{error}</h5>;
}
